import React, { useEffect } from "react";
import { Control, FieldValues, useForm } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { SelectFieldOption } from "components/UI/SelectField/SelectField.type";
import { USER_TYPE } from "constant/user/user.constant";

type UserTypeSelectProps<T extends FieldValues = FieldValues> = {
  control?: Control<T>;
  defaultValue?: string;
  label?: string;
  name?: string;
  onSelect?: (value: string) => void;
};

const USER_TYPE_SELECT_OPTIONS: SelectFieldOption[] = [
  { value: USER_TYPE.EDITOR, label: USER_TYPE.EDITOR },
  { value: USER_TYPE.ADMIN, label: USER_TYPE.ADMIN },
];

const UserTypeSelect = <T extends FieldValues = FieldValues>({
  control,
  defaultValue = USER_TYPE.EDITOR,
  label = "Tip korisnika",
  name = "uType",
  onSelect,
}: UserTypeSelectProps<T>) => {
  const { control: localControl, reset } = useForm({
    defaultValues: {
      [name]: defaultValue,
    },
  });

  useEffect(() => {
    if (!control) {
      reset({
        [name]: defaultValue,
      });
    }
  }, [control, defaultValue, name, reset]);

  return (
    <>
      <SelectField
        name={name}
        control={(control ?? localControl) as Control<any>}
        label={label}
        defaultValue={defaultValue}
        options={USER_TYPE_SELECT_OPTIONS}
        onSelect={onSelect}
      />
    </>
  );
};

export default UserTypeSelect;
